// extracted by css-extract-rspack-plugin
export default {"container":"UnreadIndicator-module__container__auSknZI"};